import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import Image from "../../custom/Image";
import Pagination from "@mui/material/Pagination";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { v4 as uuidv4 } from "uuid";
import NavBar from "../../structure/NavBar";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import AddIcon from "@mui/icons-material/Add";
import { NavBarTop } from "../../structure/NavBarTop";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useCallback, useEffect, useState } from "react";
import NoDataImg from "../../../assets/img/no-data.gif";
import {
  updateTopHeader,
  updateLoading,
} from "../../../redux/features/common/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import urls from "../../constants/apiurl";
import ApiCaller from "../../constants/ApiCaller";
import { showDangerToast, showToast } from "../../constants/toaster";
import Utils from "../../constants/Utils";
import InsufficientPermission from "../../custom/InSufficientPermission";
import { useNavigate } from "react-router-dom";
// import { AddBusinessCategory } from "./Add";
const label = { inputProps: { "aria-label": "Size switch demo" } };
export const BusinessMerchantList = (props) => {
  const navigate = useNavigate();

  const { formatDate } = Utils();
  const [callAPi, setCallAPi] = useState("");
  const LOADING_ENABLE = useSelector((state) => state?.loading);
  const [searchText, setSearchText] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [statusDropdownText, setStatusDropdownText] = useState("Select Status");
  const dispatch = useDispatch();
  const [datalist, setDatalist] = useState([]);
  const [sort_type] = useState("createdAt");
  const [sort_order] = useState(false);
  const userData = useSelector((state) => state?.userData);
  const [page, setPage] = useState(1);
  const [edit] = useState(false);

  const handleDeleteBusinessMerchant = async (id) => {
    if (
      window.confirm("Are you sure you want to delete this business merchant?")
    ) {
      try {
        dispatch(updateLoading(true));
        let path = urls.deleteBusinessMerchant + "?id=" + id;
        let res = await ApiCaller.put({}, path, userData?.access_token);
        const response = await res.response.json();
        if (response.status === 200 || response.status === "200") {
          dispatch(updateLoading(false));
          showToast(response?.message);
          getBusinessMerchantList();
        } else {
          dispatch(updateLoading(false));
          showDangerToast(
            response?.message || "Failed to delete business merchant"
          );
        }
      } catch (error) {
        dispatch(updateLoading(false));
        console.error("Error deleting business merchant:", error);
        showDangerToast(
          error?.message || "An unexpected error occurred while deleting"
        );
      }
    }
  };

  const handleChange = (event, value) => {
    if (typeof value !== "number" || value < 1) return;

    setPage(value);
    setPagerecord((prev) => ({
      ...prev,
      pageNumber: value,
      pageSize: 10,
    }));
    setCallAPi(uuidv4());
  };
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1,
  });

  const handleFilterClick = useCallback(() => {
    setPage(1);
    setPagerecord((prev) => ({
      ...prev,
      pageNumber: 1,
    }));
    setCallAPi(uuidv4());
  }, []);

  const handleResetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setStatusDropdownText("Select Status");
    setSearchText("");
    setPage(1);
    setPagerecord((prev) => ({
      ...prev,
      pageNumber: 1,
    }));
    setCallAPi(uuidv4());
  };

  const userPermisiions = useSelector((state) => state?.permission);
  let currentModulePermission;
  let viewPermission = true;
  let editPermission = true;
  let deletePermissionVal = true;
  let activePermission = true;

  if (userPermisiions?.modules.length > 0) {
    currentModulePermission = userPermisiions.modules.find(
      (element) => element.moduleId === "22"
    )?.permissions;
    viewPermission =
      currentModulePermission?.find((element) => element.name === "VIEW")
        ?.isEnable || false;
    editPermission =
      currentModulePermission?.find((element) => element.name === "EDIT")
        ?.isEnable || false;
    deletePermissionVal =
      currentModulePermission?.find((element) => element.name === "DELETE")
        ?.isEnable || false;
    activePermission =
      currentModulePermission?.find((element) => element.name === "ACTIVE")
        ?.isEnable || false;
  }

  useEffect(() => {
    dispatch(updateTopHeader("Business Merchant Manager"));
  }, [dispatch]);

  const getBusinessMerchantList = async () => {
    let startDateObject;
    let endDateObject;
    if (startDate?.toDate()) {
      let newDate = new Date(startDate?.toDate());
      newDate.setDate(newDate.getDate() + 1);
      startDateObject = newDate;
    }
    if (endDate?.toDate()) {
      // Create a new Date object based on startDate
      let newDate = new Date(endDate?.toDate());
      // Add one day
      newDate.setDate(newDate.getDate() + 1);
      endDateObject = newDate;
    }
    try {
      dispatch(updateLoading(true));
      let postJson = {
        searchTxt: searchText?.trim(),
        page: pagerecord?.pageNumber - 1 || 0,
        limit: pagerecord?.pageSize || 10,
        sort: sort_type,
        active:
          statusDropdownText === "Active"
            ? true
            : statusDropdownText === "In Active"
            ? false
            : null,
        order: sort_order,
        startDate: startDateObject !== null ? startDateObject : "",
        endDate: endDateObject !== null ? endDateObject : "",
      };
      let path = urls.businessMerchantList;
      let res = await ApiCaller.post(postJson, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status === 200 || response.status === "200") {
        dispatch(updateLoading(false));
        setDatalist(response?.data?.items || []);
        setPagerecord((prev) => ({
          ...prev,
          totalItems: response?.data?.totalItems || 0,
          totalPages: response?.data?.totalPages || 0,
          pageSize: 10,
        }));
      } else {
        dispatch(updateLoading(false));
        showDangerToast(
          response?.message || "Failed to fetch business merchant list"
        );
      }
    } catch (error) {
      dispatch(updateLoading(false));
      console.error("Error fetching business merchant list:", error);
      showDangerToast(
        error?.message || "An unexpected error occurred while fetching data"
      );
    }
  };

  const handleStatusChange = async (event, id) => {
    try {
      dispatch(updateLoading(true));
      let path = urls.changeMerchantStatus + "?id=" + id;
      let res = await ApiCaller.put({}, path, userData?.access_token);
      const response = await res.response.json();
      if (response.status === 200 || response.status === "200") {
        dispatch(updateLoading(false));
        showToast(response?.message);
        getBusinessMerchantList();
      } else {
        dispatch(updateLoading(false));
        showDangerToast(response?.message || "Failed to update status");
      }
    } catch (error) {
      dispatch(updateLoading(false));
      console.error("Error updating status:", error);
      showDangerToast(
        error?.message || "An unexpected error occurred while updating status"
      );
    }
  };

  useEffect(() => {
    if (viewPermission) {
      getBusinessMerchantList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callAPi, viewPermission]);

  return (
    <>
      <>
        <NavBar />
        <div className="main-content">
          <NavBarTop />
          <div className="header">
            <div className="logo">
              <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8"></div>
            </div>
          </div>
          {viewPermission ? (
            <>
              <div className="container-fluid mt--7">
                <div className="row">
                  <div className="col text-left">
                    <div className="card shadow">
                      <div className="card-header border-0">
                        <div className="row align-items-center text-left">
                          <div className="col">
                            <h3 className="mb-0">Business Merchant Manager</h3>
                          </div>
                          <div className="col text-right">
                            {userData.admin ? (
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={() =>
                                  console.log(
                                    "Add functionality not implemented"
                                  )
                                }
                                disabled
                              >
                                Add
                              </Button>
                            ) : edit ? (
                              <Button
                                variant="contained"
                                size="small"
                                startIcon={<AddIcon />}
                                onClick={() =>
                                  console.log(
                                    "Add functionality not implemented"
                                  )
                                }
                                disabled
                              >
                                Add
                              </Button>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-header border-0">
                        <div className="row align-items-center text-left">
                          <div className="col-md-3">
                            <InputGroup
                              className="mb-2"
                              style={{ borderRadius: "10px" }}
                            >
                              <Form.Control
                                placeholder="Search by Business Name"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                aria-label="Search by Business Name"
                              />
                            </InputGroup>
                          </div>
                          <div
                            className="col-md-2 mb-2 "
                            style={{ marginRight: "30px" }}
                          >
                            <Dropdown>
                              <Dropdown.Toggle
                                variant="success"
                                style={{
                                  backgroundColor: "white",
                                  color: "black",
                                  border: "1px solid #cad1d7",
                                  boxShadow: "none",
                                  transform: "none",
                                }}
                                id="dropdown-basic"
                              >
                                {statusDropdownText}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() =>
                                    setStatusDropdownText("Select Status")
                                  }
                                >
                                  Select Status
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() =>
                                    setStatusDropdownText("Active")
                                  }
                                >
                                  Active
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() =>
                                    setStatusDropdownText("In Active")
                                  }
                                >
                                  In Active
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div
                            className="col-md-6 mb-3"
                            style={{ marginLeft: "10px" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer
                                components={["DatePicker", "DatePicker"]}
                              >
                                <DatePicker
                                  disableFuture
                                  className="custom-date"
                                  label="From Date"
                                  value={startDate}
                                  onChange={(newValue) =>
                                    setStartDate(newValue)
                                  }
                                  maxDate={endDate}
                                />
                                <DatePicker
                                  disableFuture
                                  label="To Date"
                                  value={endDate}
                                  onChange={(newValue) => setEndDate(newValue)}
                                  minDate={startDate}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </div>
                          <div className="col-md-3 mb-2">
                            <Button
                              variant="contained"
                              className="custom-filter-btn"
                              onClick={handleFilterClick}
                            >
                              Filter
                            </Button>
                            <Button
                              variant="contained"
                              className="ml-2 custom-filter-btn"
                              onClick={handleResetFilter}
                            >
                              Reset
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        {Array.isArray(datalist) && datalist.length > 0 ? (
                          <>
                            <table className="table align-items-center table-flush">
                              <thead className="thead-light">
                                <tr>
                                  <th
                                    scope="col"
                                    className="text-center"
                                    style={{
                                      padding: "15px 8px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    S/No.
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-center"
                                    style={{
                                      padding: "15px 8px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Business Logo
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-left"
                                    style={{
                                      padding: "15px 8px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Business Name
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-center"
                                    style={{
                                      padding: "15px 8px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Approval Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-center"
                                    style={{
                                      padding: "15px 8px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Date Created
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-center"
                                    style={{
                                      padding: "15px 8px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="text-center"
                                    style={{
                                      padding: "15px 8px",
                                      verticalAlign: "middle",
                                    }}
                                  >
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {Array.isArray(datalist) &&
                                  datalist.map((data, i) => {
                                    if (!data) return null;
                                    const startIndex =
                                      (pagerecord?.pageNumber - 1 || 0) *
                                      (pagerecord?.pageSize || 10);
                                    return (
                                      <tr
                                        key={
                                          data?.uuid ||
                                          data?.id ||
                                          `business-${i}`
                                        }
                                      >
                                        <td
                                          className="text-center"
                                          style={{
                                            padding: "15px 8px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          {startIndex + i + 1}
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{
                                            padding: "15px 8px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          <Image
                                            image={{
                                              id: 1,
                                              src: data?.businessLogo,
                                            }}
                                            width="60px"
                                            height="60px"
                                            style={{
                                              borderRadius: "8px",
                                              objectFit: "cover",
                                            }}
                                          />
                                        </td>
                                        <td
                                          className="text-left"
                                          style={{
                                            padding: "15px 8px",
                                            verticalAlign: "middle",
                                            fontWeight: "500",
                                          }}
                                        >
                                          {data?.businessName}
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{
                                            padding: "15px 8px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          <span
                                            className={`badge ${
                                              data?.approved
                                                ? "badge-success"
                                                : "badge-warning"
                                            }`}
                                          >
                                            {data?.approved
                                              ? "Approved"
                                              : "Pending"}
                                          </span>
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{
                                            padding: "15px 8px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          {formatDate(data?.createdAt)}
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{
                                            padding: "15px 8px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          {userData.admin ? (
                                            <Switch
                                              {...label}
                                              checked={data?.active}
                                              onChange={(e) =>
                                                handleStatusChange(
                                                  e,
                                                  data?.uuid
                                                )
                                              }
                                              size="small"
                                            />
                                          ) : activePermission ? (
                                            <Switch
                                              {...label}
                                              checked={data?.active}
                                              onChange={(e) =>
                                                handleStatusChange(
                                                  e,
                                                  data?.uuid
                                                )
                                              }
                                              size="small"
                                            />
                                          ) : (
                                            <span className="text-muted">
                                              -
                                            </span>
                                          )}
                                        </td>
                                        <td
                                          className="text-center"
                                          style={{
                                            padding: "15px 8px",
                                            verticalAlign: "middle",
                                          }}
                                        >
                                          <div
                                            className="d-flex justify-content-center align-items-center"
                                            style={{ gap: "8px" }}
                                          >
                                            {userData.admin ? (
                                              <>
                                                <IconButton
                                                  size="small"
                                                  color="primary"
                                                  title="View Details"
                                                  onClick={() =>
                                                    navigate(
                                                      `/business-merchant-details/${data?.uuid}`
                                                    )
                                                  }
                                                  sx={{
                                                    padding: "6px",
                                                    backgroundColor:
                                                      "rgba(25, 118, 210, 0.1)",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "rgba(25, 118, 210, 0.2)",
                                                    },
                                                  }}
                                                >
                                                  <VisibilityIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                  size="small"
                                                  color="error"
                                                  title="Delete"
                                                  onClick={() =>
                                                    handleDeleteBusinessMerchant(
                                                      data?.uuid
                                                    )
                                                  }
                                                  sx={{
                                                    padding: "6px",
                                                    backgroundColor:
                                                      "rgba(211, 47, 47, 0.1)",
                                                    "&:hover": {
                                                      backgroundColor:
                                                        "rgba(211, 47, 47, 0.2)",
                                                    },
                                                  }}
                                                >
                                                  <DeleteIcon fontSize="small" />
                                                </IconButton>
                                              </>
                                            ) : (
                                              <>
                                                {editPermission && (
                                                  <IconButton
                                                    size="small"
                                                    color="primary"
                                                    title="View Details"
                                                    onClick={() =>
                                                      navigate(
                                                        `/business-merchant-details/${data?.uuid}`
                                                      )
                                                    }
                                                    sx={{
                                                      padding: "6px",
                                                      backgroundColor:
                                                        "rgba(25, 118, 210, 0.1)",
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "rgba(25, 118, 210, 0.2)",
                                                      },
                                                    }}
                                                  >
                                                    <VisibilityIcon fontSize="small" />
                                                  </IconButton>
                                                )}
                                                {deletePermissionVal && (
                                                  <IconButton
                                                    size="small"
                                                    color="error"
                                                    title="Delete"
                                                    onClick={() =>
                                                      handleDeleteBusinessMerchant(
                                                        data?.uuid
                                                      )
                                                    }
                                                    sx={{
                                                      padding: "6px",
                                                      backgroundColor:
                                                        "rgba(211, 47, 47, 0.1)",
                                                      "&:hover": {
                                                        backgroundColor:
                                                          "rgba(211, 47, 47, 0.2)",
                                                      },
                                                    }}
                                                  >
                                                    <DeleteIcon fontSize="small" />
                                                  </IconButton>
                                                )}
                                              </>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </>
                        ) : (
                          <>
                            <div
                              className="text-center"
                              style={{ padding: "40px 20px" }}
                            >
                              <img
                                width={"25%"}
                                src={NoDataImg}
                                alt="No data found"
                                style={{ marginBottom: "20px" }}
                              />
                              <br />
                              <label
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#6c757d",
                                }}
                              >
                                {LOADING_ENABLE ? (
                                  <>Loading Data...</>
                                ) : (
                                  <>No Data Found</>
                                )}
                              </label>
                            </div>
                          </>
                        )}
                      </div>
                      {Array.isArray(datalist) && datalist.length > 0 ? (
                        <>
                          <div className="card-footer py-4">
                            <Box
                              display="flex"
                              justifyContent="right"
                              alignItems="center"
                            >
                              <span>
                                Total record: {pagerecord?.totalItems}
                              </span>
                              <Pagination
                                className="custom-pagination-class"
                                count={pagerecord?.totalPages}
                                page={page}
                                onChange={handleChange}
                                color="secondary"
                              />
                            </Box>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                {/* <AddBusinessCategory
                                        show={showAddTag}
                                        tagFormData={tagFormData}
                                        setTagFormData={setTagFormData}
                                        onSubmit={(uploadedFile) => handleOnSubmitAddModel(uploadedFile)}
                                        onHide={() => handleHideForm()}
                                    /> */}
              </div>
            </>
          ) : (
            <InsufficientPermission />
          )}
        </div>
      </>
    </>
  );
};
